import Swiper from "swiper";
import { A11y, Autoplay, EffectFade } from "swiper/modules";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

tippy("[data-alumni-template]", {
  content: (ref) => {
    const id = ref.getAttribute("data-alumni-template");
    const template = document.getElementById(id);
    return template.innerHTML;
  },
  allowHTML: true,
  interactive: true,
  maxWidth: 480,
  placement: "top",
  trigger: "click",
  appendTo: document.body,
});

document.querySelectorAll(".element-alumnimap").forEach((el) => {
  const mediaSlider = el.querySelector(".alumni-media-slider .swiper");

  if (!mediaSlider) {
    return;
  }

  new Swiper(mediaSlider, {
    modules: [A11y, Autoplay, EffectFade],
    autoplay: {
      delay: 3000,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 1000,
  });
});

document.querySelectorAll(".element-alumnimap").forEach((el) => {
  const map = el.querySelector(".map");
  const mapContainer = el.querySelector(".map-container");
  const mapImage = map.querySelector("img");
  const zoomIn = el.querySelector(".map-zoom-in");
  const zoomOut = el.querySelector(".map-zoom-out");
  const rangeInput = el.querySelector('input[type="range"]');

  let mapImageWidth = mapImage.getBoundingClientRect().width;
  let mapImageHeight = mapImage.getBoundingClientRect().height;
  let isResizing = false;

  let zoomLevel = 1;
  let isDown = false;
  let startX, startY, scrollLeft, scrollTop;
  let initialDistance = null;
  let initialScale = zoomLevel;
  let initialScrollLeft = 0;
  let initialScrollTop = 0;
  let isPinching = false;
  let pinchCenterOffsetX = 0;
  let pinchCenterOffsetY = 0;

  const zoomStep = 1;
  const minZoom = 1;
  const maxZoom = 3;
  let zoomScale = 1;

  const setVars = () => {
    const isSmallScreen = window.matchMedia("(max-width: 620px)").matches;

    zoomScale = isSmallScreen ? 2 : 1;
  };

  const handleZoomIn = () => {
    if (zoomLevel + zoomStep > maxZoom) {
      zoomLevel = maxZoom;
    } else {
      zoomLevel += zoomStep;
    }

    handleZoom();
  };

  const handleZoomOut = () => {
    if (zoomLevel - zoomStep < minZoom) {
      zoomLevel = minZoom;
    } else {
      zoomLevel -= zoomStep;
    }

    handleZoom();
  };

  const handleZoom = () => {
    zoomIn.disabled = false;
    zoomOut.disabled = false;

    if (zoomLevel === minZoom) {
      zoomOut.disabled = true;
    }

    if (zoomLevel >= maxZoom) {
      zoomIn.disabled = true;
    }

    rangeInput.value = zoomLevel;

    if (zoomLevel > minZoom) {
      map.classList.add("is-zoomed");

      el.style.setProperty("--zoom-level", zoomLevel * zoomScale);
      el.style.setProperty("--scroll-left", `${map.scrollLeft}px`);
      el.style.setProperty("--scroll-top", `${map.scrollTop}px`);
      map.style.setProperty("--width", `${mapImageWidth}px`);
      map.style.setProperty("--height", `${mapImageHeight}px`);
    } else {
      map.classList.remove("is-zoomed");
      el.style.removeProperty("--zoom-level");
      el.style.removeProperty("--scroll-left");
      el.style.removeProperty("--scroll-top");
      map.style.removeProperty("--width");
      map.style.removeProperty("--height");
    }
  };

  zoomIn.addEventListener("click", handleZoomIn);
  zoomOut.addEventListener("click", handleZoomOut);

  rangeInput.addEventListener("input", (e) => {
    const value = parseInt(e.target.value, 10);

    if (value > zoomLevel) {
      handleZoomIn();
    }

    if (value < zoomLevel) {
      handleZoomOut();
    }
  });

  map.addEventListener("scroll", () => {
    if (!isPinching) {
      el.style.setProperty("--scroll-left", `${map.scrollLeft}px`);
      el.style.setProperty("--scroll-top", `${map.scrollTop}px`);
    }
  });

  map.addEventListener("mousedown", (e) => {
    isDown = true;
    startX = e.pageX - map.offsetLeft;
    startY = e.pageY - map.offsetTop;
    scrollLeft = map.scrollLeft;
    scrollTop = map.scrollTop;
  });

  map.addEventListener("mouseleave", () => {
    isDown = false;
  });

  map.addEventListener("mouseup", () => {
    isDown = false;
  });

  map.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - map.offsetLeft;
    const y = e.pageY - map.offsetTop;
    const walkX = (x - startX) * 1.2;
    const walkY = (y - startY) * 1.2;
    map.scrollLeft = scrollLeft - walkX;
    map.scrollTop = scrollTop - walkY;
  });

  map.addEventListener("wheel", (e) => {
    const delta = e.deltaY;
    const isScrollable = map.scrollHeight > map.clientHeight;
    const canScrollUp = map.scrollTop > 0;
    const canScrollDown = map.scrollTop + map.clientHeight < map.scrollHeight;

    if ((delta < 0 && !canScrollUp) || (delta > 0 && !canScrollDown)) {
      return;
    }

    if (isScrollable) {
      e.preventDefault();
    }
  });

  const getDistance = (touch1, touch2) => {
    const dx = touch1.clientX - touch2.clientX;
    const dy = touch1.clientY - touch2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  };

  const handleTouchStart = (event) => {
    if (event.touches.length === 2) {
      isPinching = true;
      initialDistance = getDistance(event.touches[0], event.touches[1]);
      initialScale = zoomLevel;
      initialScrollLeft = map.scrollLeft;
      initialScrollTop = map.scrollTop;

      const touch1 = event.touches[0];
      const touch2 = event.touches[1];
      const centerX = (touch1.clientX + touch2.clientX) / 2;
      const centerY = (touch1.clientY + touch2.clientY) / 2;

      const rect = map.getBoundingClientRect();
      pinchCenterOffsetX = centerX - rect.left + map.scrollLeft;
      pinchCenterOffsetY = centerY - rect.top + map.scrollTop;

      event.preventDefault();
    }
  };

  const handleTouchMove = (event) => {
    if (event.touches.length === 2 && initialDistance) {
      const newDistance = getDistance(event.touches[0], event.touches[1]);
      const scaleChange = newDistance / initialDistance;
      const newScale = initialScale * scaleChange;
      const clampedScale = Math.min(Math.max(newScale, minZoom), maxZoom);
      const scaleFactor = clampedScale / initialScale;

      zoomLevel = clampedScale;
      handleZoom();

      const deltaX = pinchCenterOffsetX * (scaleFactor - 1);
      const deltaY = pinchCenterOffsetY * (scaleFactor - 1);

      map.scrollLeft = initialScrollLeft + deltaX;
      map.scrollTop = initialScrollTop + deltaY;

      event.preventDefault();
    }
  };

  const handleTouchEnd = (event) => {
    if (event.touches.length < 2) {
      isPinching = false;
      initialDistance = null;
      initialScale = zoomLevel;
      initialScrollLeft = map.scrollLeft;
      initialScrollTop = map.scrollTop;
    }
  };

  map.addEventListener("touchstart", handleTouchStart, { passive: false });
  map.addEventListener("touchmove", handleTouchMove, { passive: false });
  map.addEventListener("touchend", handleTouchEnd);

  const resizeObserver = new ResizeObserver(() => {
    if (!isResizing) {
      isResizing = true;
      map.classList.remove("is-zoomed");

      setTimeout(() => {
        setVars();

        rangeInput.value = zoomLevel;

        mapImageWidth = mapImage.getBoundingClientRect().width;
        mapImageHeight = mapImage.getBoundingClientRect().height;

        handleZoom();

        isResizing = false;
      });
    }
  });

  resizeObserver.observe(mapContainer);
});
